import { mutate } from "swr";
import { setIsLoading } from "../store";
import { searchPosInArrayObject } from "@helpers/general";

export async function editCurrency(
    franchiseID: any,
    updatedRows: any,
    setDataIsUpdated: Function,
    dataIsUpdated: boolean | number,
    setIsAddDeviceClicked: Function,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/defaultSetting/data`;
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            franchiseId: franchiseID,
            types: ["currency"],
            data: updatedRows,
        }),
    };
    try {
        const data = await fetchGlobal<any>(apiUrl, requestOptions);

        if (data.error) {
            throw Error("error");
        } else {
            setDataIsUpdated(!dataIsUpdated);
            setIsAddDeviceClicked(false);
            setIsLoading(false);
            mutate(apiUrl, data);
            return true;
        }
    } catch (e) {
        setIsLoading(false);
    }
    return true;
}

export async function refreshPays(
    i18nextLng: any,
    oneShop: any,
    shopPays: any,
    setCountryList: Function,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    let apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/pays`;

    try {
        const data = await fetchGlobal<any>(apiUrl, {
            headers: {
                "Content-Type": "application/json",
                "Accept-Language": i18nextLng,
            },
            method: "GET",
        });

        if (data.error) {
            throw Error("Error!");
        }

        let listOfTag: any = [];

        data.data.forEach((element: any) => {
            listOfTag.push({
                label: element["Designation"],
                value: element.Id,
                frDesignation: element.frenchDesignation,
            });
        });

        if (oneShop) {
            let shopPaysItems =
                listOfTag[searchPosInArrayObject(listOfTag, "label", shopPays)];
            setCountryList([shopPaysItems?.label]);
        } else {
            setCountryList(data.data.map((el: any) => el.Designation));
        }

        mutate(apiUrl, data);
    } catch (e: any) {}
}
